import { useMemo } from 'react'

import { Camelize } from 'Types'

import { camelize } from './fast-case'

export type Inquiry<T extends string> = T & { [key in `is${Capitalize<Camelize<T>>}`]: boolean }

const inquiry = <T extends string>(str: T): Inquiry<T> =>
  new Proxy({} as unknown as Inquiry<T>, {
    get(_, key) {
      key = key.toString()
      const value = str[key as keyof T]
      if (value) {
        return typeof value === 'function' ? value.bind(str) : value
      } else if (key.startsWith('is')) {
        key = key.replace(/^is/, '')
        return camelize(str) === camelize(key)
      }
    },
  })

export const useInquiry = <T extends string>(str: T): Inquiry<T> => {
  return useMemo(() => inquiry(str), [str])
}

export default inquiry
